// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RowGroup .RowGroup__title {\n  padding: 4px 8px 4px 16px;\n  font-size: 14px;\n  font-weight: bold;\n  border-top: 1px solid lightgray;\n  border-bottom: 1px solid lightgray;\n  background: #fafaff; }\n\n.RowGroup .RowGroup__amount {\n  padding: 4px 8px;\n  font-size: 14px;\n  font-weight: bold;\n  text-align: right;\n  font-family: monospace;\n  border-top: 1px solid lightgray;\n  border-bottom: 1px solid lightgray;\n  background: #fafaff; }\n", ""]);
// Exports
module.exports = exports;
